// extracted by mini-css-extract-plugin
export default {"containerHorizontal":"NavLinks_containerHorizontal__6PtHz","containerVertical":"NavLinks_containerVertical__TzyuE","link":"NavLinks_link__uPvQm"};